var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_217:16365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.94 2.93H8.56L6.63 4.86H8.04L10.12 2.79C10.2123 2.69485 10.2638 2.56753 10.2638 2.435C10.2638 2.30247 10.2123 2.17515 10.12 2.08L8.04 0H6.63L8.56 1.93H3.94C3.48499 1.93077 3.03646 2.03787 2.63019 2.24274C2.22391 2.44761 1.87114 2.7446 1.6 3.11L0 5.29H1.22L2.4 3.71C2.57799 3.46879 2.80998 3.27261 3.0774 3.13717C3.34482 3.00172 3.64024 2.93077 3.94 2.93Z",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24001 7.40999H2.63002L4.56002 5.40999H3.14001L1.07001 7.49999C1.02315 7.54647 0.985956 7.60177 0.960571 7.6627C0.935187 7.72363 0.922119 7.78898 0.922119 7.85499C0.922119 7.92099 0.935187 7.98635 0.960571 8.04728C0.985956 8.10821 1.02315 8.16351 1.07001 8.20999L3.14001 10.28H4.56002L2.63002 8.40999H7.24001C7.69561 8.40467 8.14401 8.29564 8.55119 8.09119C8.95837 7.88673 9.31364 7.59222 9.59002 7.22999L11.18 5.04999H9.96001L8.78001 6.57999C8.60741 6.83042 8.37778 7.03627 8.11004 7.18058C7.8423 7.32488 7.5441 7.40351 7.24001 7.40999Z",
    fill: "#3C3C3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217:16365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.17,
    height: 10.28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon_link.8ff4a29886044ec429852a0ca47c8f08.svg";
export { ForwardRef as ReactComponent };